/**
 * Typy zpráv, které ServiceWorker odesílá klientům
 */
export enum ServiceWorkerResponseType {
    /** Oznamuje proběhlé oživení uživatelské session */
    renewSession = "renewSession",
    /** Oznamuje vypršení uživatelské session */
    sessionTimeout = "sessionTimeout",
    /** Posílá diagnostická data */
    performance = "performance",
}

interface IServiceWorkerResponseEmpty<TMessageType extends keyof ResponseTypeToPayloadMap> {
    /** Typ zprávy */
    readonly type: TMessageType;
}

interface IServiceWorkerResponse<TMessageType extends keyof ResponseTypeToPayloadMap> extends IServiceWorkerResponseEmpty<TMessageType> {
    /** Data zprávy */
	readonly payload: ResponseTypeToPayloadMap[TMessageType];
}

type ResponseTypeToPayloadMap = {
    [ServiceWorkerResponseType.renewSession]: void;
    [ServiceWorkerResponseType.sessionTimeout]: { readonly error: any; readonly statusCode: number };
    [ServiceWorkerResponseType.performance]: { readonly network: { entryType: string; name: string; startTime: number; duration: number; responseSize: number | undefined }[] };
};

/** Všechny zprávy, které ServiceWorker odesílá svým klientům (stránkám) */
export type ServiceWorkerResponse =
    IServiceWorkerResponseEmpty<ServiceWorkerResponseType.renewSession> |
    IServiceWorkerResponse<ServiceWorkerResponseType.sessionTimeout> |
    IServiceWorkerResponse<ServiceWorkerResponseType.performance>;
